import { Input, message } from 'antd';
import { useState } from 'react';

import Button from '@/components/common/Button';
import { UseTranslateType } from '@/hooks/useTranslate';
import { renameAsset } from '@/services';

import CommonModal from '..';
import styles from './style.module.scss';

interface RenameAssetModalProps {
  onOk?: (newTitle: string) => void;
  title: string;
  id: number;
}
interface ExchangeCodeProps {
  t: UseTranslateType;
  id: number;
  title: string;
  onOk?: (newTitle: string) => void;
}
const Content = ({ t, title, id, onOk }: ExchangeCodeProps) => {
  const [newTitle, setNewTitle] = useState(title);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      const res = await renameAsset({
        id,
        title: newTitle,
      });
      if (res.code === 200) {
        message.success(t('merror.rename'));
        onOk?.(newTitle);
        setLoading(false);
      } else {
        message.error(t('merror.rename.fail'));
      }
    } catch (error) {
      message.error(t('merror.rename.fail'));
    }
  };
  return (
    <>
      <div className="py-[32px] px-[42px]">
        <Input
          value={newTitle}
          className={styles['rename-asset-input']}
          onChange={(e) => {
            setNewTitle(e.target.value);
          }}
        />
      </div>
      <div className="w-full h-[60px] flex justify-end items-center pl-[40px] pr-[16px]">
        <Button
          loading={loading}
          onClick={onSubmit}
          disabled={newTitle.length < 1}
          className="w-[142px] h-[36px]"
        >
          {t('merror.operate.ok')}
        </Button>
      </div>
    </>
  );
};
export function renameAssertModalShow(options: RenameAssetModalProps) {
  CommonModal.show((t) => ({
    width: 800,
    title: t('merror.setting.rename'),
    customPadding: {
      x: 0,
      y: 0,
    },
    footer: false,
    onCancel: () => {},
    content: (close) => (
      <Content
        t={t}
        {...options}
        onOk={(newTitle: string) => {
          close();
          options.onOk?.(newTitle);
        }}
      />
    ),
  }));
}
